import { forwardRef } from "react"
import { mergeClasses } from "@lib/css"

import type { IconProps } from "./types"

export const IconArrowUp = forwardRef<SVGSVGElement, IconProps>(
  function IconArrowUp(props, ref) {
    const { className, title, titleId, ...otherProps } = props
    const defaultClasses =
      "w-8 h-8 flex-shrink-0 fill-current transition-colors duration-150 ease-in focus:outline-none"
    const classes = mergeClasses(defaultClasses, className)

    return (
      <svg
        ref={ref}
        viewBox="0 0 32 32"
        focusable="false"
        aria-hidden="true"
        tabIndex={-1}
        className={classes}
        aria-labelledby={titleId}
        {...otherProps}
      >
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M15.861 10.5464L4.41487 21.9924L2.15217 19.7297L15.861 6.02087L29.7622 19.9221L27.4995 22.1849L15.861 10.5464Z" />
        <path d="M15.861 10.5464L4.41487 21.9924L2.15217 19.7297L15.861 6.02087L29.7622 19.9221L27.4995 22.1849L15.861 10.5464Z" />
      </svg>
    )
  },
)
